module.exports = __webpack_public_path__ + "static/media/shopeepaylogo.68e84f04.jpg";